<template>
  <nav>
    <AlertMessages v-if="alertValue" :alert-type="alertType" :alert-msg="alertMsg" @reset="alertValue = false" />
    <v-row>
      <v-col :cols="mobile() ? '12' : '11'" :class="mobile() ? '' : 'mx-auto'">
        <span class="float-right">
          <v-menu v-if="mobile()" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class=" px-5 py-2" height="100%" icon v-bind="attrs" v-on="on">
                <v-icon large>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list class="menulist-drawer" data-testid="menu-list">
              <v-list-item @click="showUsersStatus">
                <v-list-item-title>{{ $t('userStatusItem') }}</v-list-item-title>
              </v-list-item>
              <v-list-item class="accent--text" @click="showSettings">
                <v-list-item-title>{{ $t('settingsItem') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
        <p :class="mobile() ? 'text-h5 font-weight-bold ml-16 mr-16' : 'text-h5 font-weight-bold'"
          :align="mobile() ? 'center' : 'left'">
          {{ $t('settingsPlanday') }}
        </p>
      </v-col>
      <v-col v-if="!mobile()" :cols="mobile() ? '12' : '11'"
        :class="mobile() ? 'custom-tab-menu py-0' : 'mx-auto custom-tab-menu py-0'">
        <v-list class="py-0" flat>
          <v-list-item @click="showUsersStatus">
            {{ $t('userStatusItem') }}
          </v-list-item>
          <v-list-item class="accent--text" @click="showSettings">
            {{ $t('settingsItem') }}
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row v-if="!loadingData">
      <v-col :cols="mobile() ? '12' : '11'" :class="mobile() ? '' : 'mx-auto'">

        <v-form ref="form" @submit.prevent>
          <v-card color="background" elevation="0" max-width="700px">
            <v-card-text>
              <p class="text-body-1 darktext--text no-break mb-2 ml-5">
                {{ $t('labelAppId') }}
              </p>
              <v-text-field v-model="appId" data-testid="app-id-input" solo class="rounded-xxl text-body-2"
                hide-details="auto" :placeholder="$t('plandayAppIdPlaceholder')" :rules="appIdRules"/>
              <p class="text-body-1 darktext--text no-break mt-4 mb-2 ml-5">
                {{ $t('labelToken') }}
              </p>
              <v-text-field v-model="token" data-testid="token-input" solo class="rounded-xxl text-body-2"
                hide-details="auto" :placeholder="$t('plandayTokenPlaceholder')" :rules="tokenRules"/>
            </v-card-text>
            <v-card-text class="checkbox-align-start">
              <v-checkbox
                v-model="checkedDoNotSendUserCredentials"
                data-testid="do-not-send-user-credentials-checkbox"
                color="accent"
                class="black--text option rounded-xxl ma-0 ml-4 mb-4 planday-user-credentials-checkbox"
                :class="{ 'selected' : checkedDoNotSendUserCredentials}"
                hide-details="auto"
                persistent-hint
                :hint="$t('plandayUserCredentialsCheckboxHint')"
              >
                <template v-slot:label>
                  <div>
                    <span class="text-subtitle-1 darktext--text font-weight-regular">{{ $t('plandayUserCredentialsCheckboxLabel') }}</span><br/>
                  </div>
                </template>
              </v-checkbox>
              <v-checkbox
                v-model="checkedRemoveUnexisting"
                data-testid="remove-unexisting-users-checkbox"
                color="accent"
                class="black--text option rounded-xxl ma-0 ml-4 mb-4 planday-remove-unexisting-checkbox"
                :class="{ 'selected' : checkedRemoveUnexisting}"
                hide-details="auto"
              >
                <template v-slot:label>
                  <div>
                    <span class="text-subtitle-1 darktext--text font-weight-regular">{{ $t('plandayRemoveUnexistingCheckboxLabel') }}</span><br/>
                  </div>
                </template>
              </v-checkbox>
              <v-checkbox
                v-model="checkedAutomaticallySyncUsers"
                data-testid="auto-sync-checkbox"
                color="accent"
                class="black--text option rounded-xxl ma-0 ml-4 mb-4 planday-auto-sync-checkbox"
                :class="{ 'selected' : checkedAutomaticallySyncUsers}"
                hide-details="auto"
                persistent-hint
                :hint="$t('plandayAutoSyncCheckboxHint')"
              >
                <template v-slot:label>
                  <div>
                    <span class="text-subtitle-1 darktext--text font-weight-regular">{{ $t('plandayAutoSyncCheckboxLabel') }}</span><br/>
                  </div>
                </template>
              </v-checkbox>
            </v-card-text>
            <v-card-actions>
              <v-btn ref="test" data-testid="test-button" color="darktext" min-width="100" dark elevation="0" outlined
                class="rounded-xxl text-none px-4" @click="testIntegration()">
                {{ $t('testConnection') }}
              </v-btn>
              <v-btn ref="submit" data-testid="submit-button" type="submit" color="accent" min-width="100" dark
                elevation="0" class="rounded-xxl text-none px-4" @click="integrationId ? updateIntegration() : saveIntegration()">
                {{ $t('save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages from '../../components/AlertMessages'
import { getIntegrations, saveIntegration, updateIntegration } from "../../api/spaceApi";
import { ruleRequired } from '../../rules/formRules.js';

export default {
  components: {
    AlertMessages
  },
  mixins: [repeatedMethodsMixin],

  data() {
    return {
      alertMsg: '',
      alertType: '',
      alertValue: false,
      loadingData: false,
      integrationId: null,
      appId: null,
      token: null,
      spaceId: window.$cookies.get("space_id"),
      appIdRules: ruleRequired('labelAppId'),
      tokenRules: ruleRequired('labelToken'),
      valid: true,
      authToken : null,
      checkedDoNotSendUserCredentials: false,
      checkedRemoveUnexisting: false,
      checkedAutomaticallySyncUsers: false
    }
  },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
  },
  async created() {
    this.loadingData = true
    await this.fetchIntegrations()
    this.loadingData = false

  },
  methods: {
    showUsersStatus() {
      this.$router.push({ path: '/space/planday-users' })
    },
    showSettings() {
      this.$router.push({ path: '/space/planday-settings' })
    },
    async fetchIntegrations() {
      try {
        const response = await getIntegrations(this.spaceId)
        if (response.status) {
          if (response.status == 200) {
            if (response.data.data.length > 0) {
              this.token = response.data.data.find(item => item.attributes.name == 'planday' ).attributes.token
              this.appId = response.data.data.find(item => item.attributes.name == 'planday' ).attributes.app_id
              this.integrationId = response.data.data.find(item => item.attributes.name == 'planday' ).id
              this.checkedDoNotSendUserCredentials = response.data.data.find(item => item.attributes.name == 'planday' ).attributes.disable_email
              this.checkedRemoveUnexisting = response.data.data.find(item => item.attributes.name == 'planday' ).attributes.remove_unexisting
              this.checkedAutomaticallySyncUsers = response.data.data.find(item => item.attributes.name == 'planday' ).attributes.auto_sync
            }
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          }
          else if (e.response.status == 403) {
            this.$router.push({ name: 'PageAccessDenied' })
          } else {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },
    
    async testIntegration() {
      this.valid = this.$refs.form.validate()
      if(this.valid){ 
        var data = {}
        try {
          if(this.integrationId){
            data = {
              data: {
                type: "integrations",
                id: this.integrationId,
                attributes: {
                  app_id: this.appId,
                  token: this.token,
                  name: "planday",
                  test: true
                },
                relationships: {
                  space: {
                    data: {
                      type: "spaces",
                      id: this.spaceId
                    }
                  },
                }
              }
            }
          }else {
            data = {
              data: {
                type: "integrations",
                attributes: {
                  app_id: this.appId,
                  token: this.token,
                  name: "planday",
                  test: true
                },
                relationships: {
                  space: {
                    data: {
                      type: "spaces",
                      id: this.spaceId
                    }
                  },
                }
              }
            }
          }
          
          const response = this.integrationId ? await updateIntegration(this.integrationId, data) : await saveIntegration(data)
          if (response.status == 200) {
            this.alertValue = true
            this.alertType = 'success'
            this.alertMsg = i18n.t('testPlandayIntegrationSuccess')
            this.authToken = response.data.meta.token
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status == 403) {
              for (let i = 0; i < e.response.data.errors.length; i++) {
                if (
                  e.response.data.errors[i].title ==
                  "integration_error"
                ) {
                  this.alertValue = true;
                  this.alertType = "error";
                  this.alertMsg = i18n.t("testPlandayIntegrationError");
                } else {
                  this.alertValue = true;
                  this.alertType = "error";
                  this.alertMsg = i18n.t("serverError");
                }
              }
            } else {
              this.alertValue = true
              this.alertType = 'error'
              this.alertMsg = i18n.t('serverError')
            }
          }
        }
      }
    },

    async saveIntegration() {
      this.valid = this.$refs.form.validate()
      if(this.valid){ 
        try {
          let data = {
            data: {
              type: "integrations",
              attributes: {
                app_id: this.appId,
                token: this.token,
                name: "planday",
                test: false,
                disable_email: this.checkedDoNotSendUserCredentials,
                remove_unexisting: this.checkedRemoveUnexisting,
                auto_sync: this.checkedAutomaticallySyncUsers
              },
              relationships: {
                space: {
                  data: {
                    type: "spaces",
                    id: this.spaceId
                  }
                },
              }
            }
          }
          const response = await saveIntegration(data)
          if (response.status == 201) {
            this.alertValue = true
            this.alertType = 'success'
            this.alertMsg = i18n.t('savePlandayIntegrationSuccess')
            this.integrationId = response.data.data.id
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },
    async updateIntegration() {
      this.valid = this.$refs.form.validate()
      if(this.valid){ 
        try {
          let data = {
            data: {
              type: "integrations",
              id: this.integrationId,
              attributes: {
                app_id: this.appId,
                token: this.token,
                name: "planday",
                test: false,
                disable_email: this.checkedDoNotSendUserCredentials,
                remove_unexisting: this.checkedRemoveUnexisting,
                auto_sync: this.checkedAutomaticallySyncUsers
              },
              relationships: {
                space: {
                  data: {
                    type: "spaces",
                    id: this.spaceId
                  }
                },
              }
            }
          }
          const response = await updateIntegration(this.integrationId, data)
          if (response.status == 200) {
            this.alertValue = true
            this.alertType = 'success'
            this.alertMsg = i18n.t('savePlandayIntegrationSuccess')
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    }
  }
}
</script>
